import React, { useState } from 'react';
import PropTypes from 'prop-types'
import { KeepAspectRatio } from '@myplay/ui';

import { Record, ScheduleRecord, SiteScheduleRecordings, Live } from '..';
import MenuOverlay from './MenuOverlay';
import LiveRecordInfoRow from './LiveRecordInfoRow';
import ScheduleRow from './ScheduleRow';
import { SCHEDULE, RECORD, LIVE, SCHEDULED_RECORDINGS } from '../../utils/constants';
import "./SingleSite.scss";
import I18N from '../../I18N';

const SingleSite = ({ site, onDeleteTask }) => {
  const { name, snapshot, isRecording, liveState: { isLive }, recordingTeam, scheduledTasks, liveBroadcastingTeam, isOnline } = site;
  const [isFocused, setIsFocused] = useState(false);
  const [pickedMenuItem, setPickedMenuItem] = useState("");

  const handleMenuItemClick = item => {
    setPickedMenuItem(item);
  };

  const handleClose = () => {
    setPickedMenuItem("");
  };

  const handleDelete = task => {
    onDeleteTask(task, site._id);
  };

  return (
    <div
      className="single-site"
      onMouseEnter={() => setIsFocused(true)}
      onMouseLeave={() => setIsFocused(false)}
      data-testid="single-site"
    >
      {!isOnline &&
        <div className="single-site__offline-badge">
          <span>{I18N.t("OFFLINE").toUpperCase()}</span>
        </div>
      }
      <KeepAspectRatio adjustAcordingToWidth>
        <div className="single-site__image-menu-box">
          {!pickedMenuItem ?
            <MenuOverlay isFocused={isFocused} onItemClick={handleMenuItemClick} isOnline={isOnline} /> :
            <div className="single-site__image-menu-box__rendered-component-wrapper">
              {pickedMenuItem === RECORD && <Record onClose={handleClose} site={site} />}
              {pickedMenuItem === SCHEDULE && <ScheduleRecord onClose={handleClose} />}
              {pickedMenuItem === LIVE && <Live onClose={handleClose} site={site} />}
              {pickedMenuItem === SCHEDULED_RECORDINGS && <SiteScheduleRecordings records={scheduledTasks} onClose={handleClose} onDelete={handleDelete} />}
            </div>
          }
          <img src={snapshot} className="single-site__image-menu-box__image" alt="" />
        </div>
      </KeepAspectRatio>
      <div className="single-site__info">
        <span className="single-site__info__team-name">{name}</span>
        <LiveRecordInfoRow isRecording={isRecording} isLive={isLive} teamNameLive={liveBroadcastingTeam} teamNameRecord={recordingTeam} />
        <ScheduleRow task={scheduledTasks.length > 0 ? scheduledTasks[0] : {}} onClick={() => handleMenuItemClick(SCHEDULED_RECORDINGS)} />
      </div>
    </div>
  );
};

SingleSite.propTypes = {
  onDeleteTask: PropTypes.func,
  site: PropTypes.object
};

SingleSite.defaultProps = {
  onDeleteTask: ()=> {}, 
  site: {}
};

export default SingleSite;